import { QueryHookResult, useGenericQuery } from '../useGenericQuery'
import { queryKeys } from '../queryRegistry'
import { SecurityRoleDTO } from 'axiosApi/models';
import { useApi } from 'api/ApiProvider';
import Api from 'axiosApi/api';

export const useRoleQuery = (): QueryHookResult<SecurityRoleDTO> => {
  const { employeeApi }: Api = useApi()
  return useGenericQuery<SecurityRoleDTO>({
    queryKey: queryKeys.roles,
    queryFn: async (): Promise<SecurityRoleDTO[]> => {
      const response = await employeeApi.apiVversionSecurityRoleAllGet("1", 1, 100)
      const { data } = response?.data;
      return data.queryResult || [];
    },
  })
}